import { createAction, props } from '@ngrx/store';

import { AssistantSize } from './assistant.state';

/**
 * Actions für das Assistent-Panel.
 *
 * Der AssistantPanelService besitzt bewusst keine öffentliche Open-/Close-API -
 * jede Zustandsänderung läuft über diese Actions. Vorbild sind das
 * provideDialogs-Muster der jf-lib und der UiService der Fakturierung.
 */
export class AssistantActions {
  private static readonly prefix = '[Assistant]';

  public static toggle = createAction(
    `${this.prefix} Toggle panel`,
  );

  public static open = createAction(
    `${this.prefix} Open panel`,
  );

  /** Das Overlay wird dabei nur verborgen, nicht zerstört. */
  public static close = createAction(
    `${this.prefix} Close panel`,
  );

  public static toggleSize = createAction(
    `${this.prefix} Toggle size`,
  );

  /**
   * Trägt die aus dem Browser-Speicher gelesene Größe ein, einmal beim Start.
   * Eine eigene Action statt eines Initialwerts, weil das Lesen fehlschlagen
   * darf und der Reducer rein bleiben muss.
   */
  public static restoreSize = createAction(
    `${this.prefix} Restore size`,
    props<{ size: AssistantSize }>(),
  );

  /**
   * Setzt die Sichtbarkeit zurück - die gemerkte Größe bleibt. Wird beim
   * Verlassen des Standalone-Bereichs dispatcht, weil der global registrierte
   * Slice den komponentenlokalen Service sonst überlebte.
   */
  public static reset = createAction(
    `${this.prefix} Reset state`,
  );
}
